import styled from 'styled-components';

const TooltipSpan = styled.span`
  position: relative;
`;

export default TooltipSpan;
